import React from 'react';
import { ToolbarButton } from '@mui/x-data-grid-pro';
import SaveIcon from '@mui/icons-material/Save';
import Tooltip from '@mui/material/Tooltip';

const SaveViewButton = (props) => {
    const label = props.buttonName || 'Save View';
    return (
        <Tooltip title={label}>
            <ToolbarButton onClick={props.onClick}>
                <SaveIcon fontSize="small" />
            </ToolbarButton>
        </Tooltip>
    );
};

export default SaveViewButton;